const INITIAL_STATE = {
  data: {},
  errors: {},
};

const SaveFieldService = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case "SAVE_FIELD_SERVICE_SUCCESSFULLY":
    return { ...INITIAL_STATE, data: action.data };
  case "SAVE_FIELD_SERVICE_FAILED":
    return { ...INITIAL_STATE, errors: action.data };
  default:
    return { ...state };
  }
};

export default SaveFieldService;
